// extracted by mini-css-extract-plugin
export default {"cls1":"OQ9davh1mEHvu60L0xKu","cls2":"QHz3FSzLLHtaBwRvG3AH OQ9davh1mEHvu60L0xKu"};